import styled from "styled-components";

export const CarouselWrapper = styled.div`
  width: 80%;
  margin: 0 auto 100px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    .slick-list{
      padding: 0 50% 0 50% !important;
    }
    width: 100%;

  `}
`;
